import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';
import {toInt} from '../../../../../lib/helpers';
import {X9Content, X9ContentSnapshot} from '../../../../../domain';
import {ReactNodeGenerator} from '../../../../../lib/helpers';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {SelectItem, SelectQuestionModel, SelectQuestionParagraph, TextItem} from '../models';
import {positionToItemId, SelectStates, SelectQuestionState, SelectState} from './models';
import {SelectQuestionStore} from './SelectQuestionStore';

interface Props {
  x9: X9Content | X9ContentSnapshot
  store: X9ContentStateStore
}

function renderTextItem(item: TextItem, key: number): React.ReactNode {
  return <span className="text-item" key={key}>{item.content}</span>;
}

function renderSelectItem(store: SelectQuestionStore,
                          paragraphIndex: number,
                          itemIndex: number,
                          item: SelectItem): React.ReactNode {
  const itemId = positionToItemId(paragraphIndex, itemIndex);
  const state = store.selectQuestionState.states[itemId];
  const correctIndex = item.choices.findIndex(x => x.selected);
  const checked = state.checked;
  const correct = checked && correctIndex === state.selected;
  const incorrect = checked && correctIndex !== state.selected;
  const disabled = correct;
  const options = store.selectOptionsById.get(itemId)!;

  const classname = classNames('select-item',
    {correct: correct, incorrect: incorrect});
  const value = state.selected === null ? '' : state.selected;

  return (
    <select key={itemIndex}
            className={classname}
            onChange={(event) => store.changeHandler(itemId, event)}
            value={value}
            disabled={disabled}>
      <option key="" value="" label=""/>
      {
        options.map((option, index) => (
          <option key={index} value={option.value}>{option.label}</option>
        ))
      }
    </select>);
}

function renderSelectAnswer(key: number,
                            item: SelectItem): React.ReactNode {
  const answer = item.choices.find(x => x.selected)!;
  return (
    <span className="select-answer" key={'answer' + key}>
      {answer.label}
    </span>);
}

function* renderParagraphItems(store: SelectQuestionStore,
                               paragraphIndex: number,
                               paragraph: SelectQuestionParagraph): ReactNodeGenerator {
  for (let i = 0; i < paragraph.items.length; i++) {
    let item = paragraph.items[i];
    if (item.type === 'text')
      yield renderTextItem(item, i);
    if (item.type === 'select')
      yield renderSelectItem(store, paragraphIndex, i, item);
    if (item.type === 'select')
      yield renderSelectAnswer(i, item);
  }
}

function* renderParagraphs(store: SelectQuestionStore): ReactNodeGenerator {
  const paragraphs = store.model.paragraphs;

  for (let i = 0; i < paragraphs.length; i++) {
    yield (
      <div className="select-question-paragraph" key={i}>
        {Array.from(renderParagraphItems(store, i, paragraphs[i]))}
      </div>);
  }
}

@observer
export class TeacherSelectQuestion extends React.Component<Props> {
  readonly store: SelectQuestionStore;

  constructor(props: Readonly<Props>) {
    super(props);
    const model = JSON.parse(this.props.x9.Contents) as SelectQuestionModel;
    this.store = new SelectQuestionStore(this.props.x9.Id,
      model, this.props.store);
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col">
            <div className="select-question teacher">
              {Array.from(renderParagraphs(this.store))}
            </div>
          </div>
        </div>
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={this.store.check}>
              Check
            </button>
          </div>
        </div>
      </>);
  }
}
